<script>
import resources from './resources'

export default {
  name: 'professional-profile',

  mixins: [resources]
}
</script>

<template lang="pug">
    .col-xs-12.white-bg.professional-profile
      .row
        .col-xs-12.col-sm-4.col-md-2
          div
            .profile-photo
              img.img-circle(:src='profile.professional.avatar')
            .links
              ul
                //- social linkedin
                a(v-if="profile.professional.networks.linkedin", :href='profile.professional.networks.linkedin', target="_blank")
                  li
                    img(src='/static/images/icons/linkedin-icon.svg')
                a.mb-cursor-point(v-if="!profile.professional.networks.linkedin")
                  li
                    img(src='/static/images/icons/linkedin-icon.svg')

                //- profile professional
                a(href='#')
                  li
                    img(src='/static/images/icons/perfil-icon.svg')

                //- social professional lattes
                a(v-if="profile.professional.networks.lattes", :href='profile.professional.networks.lattes', target="_blank")
                  li
                    img(src='/static/images/icons/share-icon.svg')
                a.mb-cursor-point(v-if="!profile.professional.networks.lattes")
                  li
                    img(src='/static/images/icons/share-icon.svg')

        .col-xs-12.col-sm-8.col-md-5.profissional-info.professional-profile-modal-serach
          h6
            | {{ profile.professional_name }}
            br
            span.crm CRM {{ profile.document }} &nbsp; - &nbsp; {{ profile.professional_state }}
            br
            small {{ profile.speciality }}
            br
          .info(style="margin-top: 80px") {{ getSpecialities }}
          .info {{ profile.company_slug }} &mdash; {{ typeClinic }}
          .adress
            | {{ profile.street }} - {{ profile.number }}
            br
            | {{ profile.zip }} - {{ profile.district }} - {{ profile.city }} - {{ profile.state }}
          .planos(v-if="profile.covenant")
            span(v-for="covenants in profile.covenant.split(',')" :tag="covenants")
              | {{ covenants }}
            covenant(:covenant="covenant", v-for="covenant in profile.covenants", :key="covenant.id")

          .consulta-particular(v-if="profile.price")
              small.mb-cursor-point.price-search(@click.prevent="isShowPrice = !isShowPrice")
                span.icon 
                | Consulta Particular

              div(v-show="isShowPrice", style="margin-left: 10px;")
                span.rs R$
                span.valor {{ profile._parsed.price_real }}
                span.cents ,{{ profile._parsed.price_cents }}
                span.cents(v-if="!profile._parsed.price_cents")
                  | 00

        .col-xs-12.col-sm-5.col-md-offset-0
          .agendas
            .h5-title
              h5 Agendas Disponíveis
              schedule(:agenda="profile")
      .row
        .col-xs-12.col-sm-8.col-md-12.col-md-offset-0(v-if="profile.latitude && profile.longitude")
          .h5-title
            h5 Localização
          maps(:latitude='profile.latitude', :longitude='profile.longitude', v-if="profile.latitude && profile.longitude")
        .col-xs-12.col-sm-8.col-md-8.formacao-profissional(v-if="(profile.professional.specializations.length > 0) || (profile.professional.graduations)")
          .h5-title
            h5 Formação Profissional

          specializations(:specialization="specialization", v-for="specialization in profile.professional.specializations", :key="specialization.id")
          hr
          graduations(:graduation='graduation',  v-for='graduation in profile.professional.graduations', :key="graduation.id")

        .col-xs-12.col-sm-8.col-md-4.formacao-profissional
          .fotos-prestador
            .h5-title
              h5 Mais fotos deste Prestador
            .gallery
              .columns
                div
                  img.img-rounded(src='/static/images/consultorio.jpg', alt='Consultório')

        .col-xs-12.col-sm-8.col-sm-offset-4.hidden-md.hidden-lg.text-left
</template>
<style scoped>
  small {
    font-size: 12px;
  }
  .consulta-particular {
    margin-top: 20px;
  }
  h6 span {
      color: #898989;
      font-size: 15px;
      font-weight: bold;
      position: relative;
  }
</style>


// WEBPACK FOOTER //
// src/app/patient/agendas/search/results/components/professional/profile.vue